export const searchNavData = [
    {
        id: 1,
        text: 'All',
        icon: 'target',
        color: 'primary'
    },
    {
        id: 2,
        text: 'Images',
        icon: 'image',
        color: 'secondary',
    },
    {
        id: 3,
        text: 'Videos',
        icon: 'video-clapper',
        color: 'success',
    },
    {
        id: 4,
        text: 'Audios',
        icon: 'map-alt',
        color: 'danger',
    },
    {
        id: 5,
        text: 'Settings',
        color: 'warning',
    },
    {
        id: 6,
        text: 'Tools',
        color: 'secondary',
    },
];

export const imageTabData = ["01","02","03","04","05","011","010","08"]